import { PhysicalAttackSkill, SpecialAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";
import { Ability } from "../../core/ablvl";

import * as type from "../../core/type";
import * as state from "../../core/state";
import * as effect from "../../core/effect";
import * as cond from "../../core/cond";
import * as pred from "../../core/pred";

export const 炫·灭影绝壑 = new PhysicalAttackSkill(
    "炫·灭影绝壑",
    type.地面·暗影,
    [
        "3回合内，每回合吸取对手最大体力的1/3",
        "3回合内，每回合令对手防御-1，速度-1",
        "若自身为地面·暗影系，则造成的伤害额外提升100%",
        "若自身不为地面·暗影系，则2回合内令对手属性技能无效",
    ],
    80,
    [
    ],
    3,
    false,
);

export const 炫·乾坤绝弑 = new PhysicalAttackSkill(
    "炫·乾坤绝弑",
    type.普通,
    [
        "若自身为暗影系，则切换为地面系，切换成功后自身进入山神守护状态",
        "若自身为地面系，则切换为暗影系，切换成功后自身进入融入黑暗状态",
        "若自身为地面·暗影系，则触发诅咒之子专属效果",
    ],
    120,
    [],
    3,
    true,
);

export const 炫·万山绝影 = new StatusSkill(
    "炫·万山绝影",
    [
        "全属性+1"
    ],
    [
        new Effect(new effect.强化(), Timing.onSkillHit)
    ],
);

export const 炫彩·九幽劫 = new PhysicalAttackSkill(
    "炫彩·九幽劫",
    type.暗影,
    [],
    160,
    [],
    0,
    true
);


export const 炫彩·山河烬 = new PhysicalAttackSkill(
    "炫彩·山河烬",
    type.地面,
    [],
    160,
    [],
    0,
    true
);
